export default function SvgHome4() {
    return (
      <>
      <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      cursor="pointer"
      fill="#80ff80"
      enableBackground="new 0 0 176.532 176.532"
      version="1.1"
      viewBox="0 0 176.532 176.532"
      xmlSpace="preserve"
    >
      <g>
        <path d="M152.928 85.912l-59.89-49.406a7.497 7.497 0 00-9.545 0l-59.89 49.406a7.497 7.497 0 00-2.728 5.785v74.544c0 4.143 3.357 7.5 7.5 7.5h119.779c4.143 0 7.5-3.357 7.5-7.5V91.697a7.489 7.489 0 00-2.726-5.785zm-56.732 72.829h-15.86v-41.524h15.859v41.524zm44.46 0h-29.46v-49.024c0-4.143-3.357-7.5-7.5-7.5h-30.86a7.499 7.499 0 00-7.5 7.5v49.024h-29.46V95.233l52.39-43.219 52.39 43.219v63.508z"></path>
        <path d="M173.72 70.866a4625.922 4625.922 0 01-49.561-40.261c-5.109-4.591-10.479-8.938-15.675-13.144-5.087-4.118-10.348-8.377-15.201-12.745a7.499 7.499 0 00-10.035 0c-4.854 4.368-10.114 8.627-15.201 12.745-5.195 4.205-10.565 8.553-15.675 13.144a4603.882 4603.882 0 01-49.56 40.261 7.5 7.5 0 009.377 11.707A4604.86 4604.86 0 0062.034 42.08c.085-.069.168-.141.25-.215 4.854-4.368 10.114-8.627 15.201-12.745 3.559-2.88 7.199-5.827 10.781-8.873 3.582 3.046 7.223 5.993 10.781 8.873 5.087 4.118 10.348 8.377 15.201 12.745.082.074.165.146.25.215a4595.155 4595.155 0 0049.845 40.493 7.47 7.47 0 004.684 1.646 7.484 7.484 0 005.858-2.812 7.498 7.498 0 00-1.165-10.541z"></path>
      </g>
    </svg>
   </>
  );
 }